import { useRef } from 'react';
import uuid from 'uuid';

/**
    useExperienceId can be used to generate unique
    experienceIds to pass to a <ViewExperienceTrackingProvider />

    This can be useful for apps with filters or controls where
    a new request is fired everytime one of these is changed.
    Each new request represents a new experience that needs
    to be tracked independently.

    @param {boolean} isLoading - Is there a request in flight for this experience?
    @returns {string} - Returns a unique experience id anytime isLoading transitions from false -> true
 */
export const useExperienceId = (isLoading: boolean) => {
	const wasLoading = useRef<boolean>(isLoading);
	const experienceId = useRef<string>(uuid());

	if (!wasLoading.current && isLoading) {
		experienceId.current = uuid();
	}

	wasLoading.current = isLoading;

	return experienceId.current;
};
